import styled from 'styled-components';

export const TableContainer = styled.div`
  height: 100%;
  height: 300px;
  margin-top: 16px;
`;
